/**
 * Directives Module
 */
import { NgModule } from '@angular/core';
import { FocusOnClickDirective } from './focus-on-click.directive';
import { ThrottleClickDirective } from './throttle-click-directive';
import { VirtualKeyboardDirective } from './virtual-keyboard.directive';
import { ClickOutsideDirective } from './click-outside/click-outside.directive';
const DIRECTIVES = [
  ClickOutsideDirective,
  VirtualKeyboardDirective,
  FocusOnClickDirective,
  ThrottleClickDirective,
];

@NgModule({
  declarations: DIRECTIVES,
  exports: DIRECTIVES,
})
export class DirectivesModule {}
